import { render, staticRenderFns } from "./CdsMenu.vue?vue&type=template&id=2c4794e8&scoped=true&"
import script from "./CdsMenu.vue?vue&type=script&lang=js&"
export * from "./CdsMenu.vue?vue&type=script&lang=js&"
import style0 from "./CdsMenu.vue?vue&type=style&index=0&id=2c4794e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4794e8",
  null
  
)

export default component.exports